import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconArrowLeft } from 'assets/icons/arrow-left.svg'
import useStyles from './styles'

const TitleNavigation = props => {
  const { page, goTo } = props
  const classes = useStyles()
  const history = useHistory()

  const goBack = () => {
    if (goTo) {
      history.push(goTo)
    } else {
      history.goBack()
    }
  }
  return (
    <Button
      color="primary"
      className={classes.root}
      onClick={goBack}
      startIcon={<SvgIcon component={IconArrowLeft} />}
    >
      {page}
    </Button>
  )
}

TitleNavigation.propTypes = {
  page: PropTypes.string,
}

export default TitleNavigation
